import { render, staticRenderFns } from "./ConfirmSendPoDialog.vue?vue&type=template&id=0b855e18&"
import script from "./ConfirmSendPoDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmSendPoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports